export default __webpack_public_path__ + "static/why_choose_crm-3bde600eb546cee402ae73ebec7d444d.webp";